import { ToastVariant } from "./ToastVariant";

export const RoleToastMessages = {
  createRoleSuccess: {
    message: "Role created successfully",
    variant: ToastVariant.Success,
  },
  createRoleError: {
    message: "Role creation failed",
    variant: ToastVariant.Error,
  },
  editRoleSuccess: {
    message: "Role updated successfully",
    variant: ToastVariant.Success,
  },
  editRoleError: {
    message: "Role update failed",
    variant: ToastVariant.Error,
  },
  addMemberSuccess: {
    message: "Member(s) added successfully",
    variant: ToastVariant.Success,
  },
  addMemberError: {
    message: "Member adding failed",
    variant: ToastVariant.Error,
  },
  switchMemberSuccess: {
    message: "Member role changed successfully",
    variant: ToastVariant.Success,
  },
  switchMemberError: {
    message: "Member role change failed",
    variant: ToastVariant.Error,
  },
  deleteRoleSuccess: {
    message: "Role deleted successfully",
    variant: ToastVariant.Success,
  },
  deleteRoleError: {
    message: "Role deletion failed",
    variant: ToastVariant.Error,
  },
};
